function trackPaymentIntentError(paymentIntent) {
  window.analytics.track('Donation Attempt Failure', {
    client_side: true,
    payment_intent_id: paymentIntent.id,
    last_payment_error: {
      code: paymentIntent.last_payment_error.code,
      message: paymentIntent.last_payment_error.message,
    },
  });
}

export {trackPaymentIntentError};
